import React, { useState, useEffect } from 'react';
import {
  Tabs,
  Form,
  DatePicker,
  Select,
  Table,
  Checkbox,
  message,
  Col,
  Row,
  Input
} from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
// , EyeOutlined
import moment from 'moment';
import CustomModal from '@/common/CustomModal';
import CustomButton from '@/common/CustomButton';
import FormItem from '@/common/FormItem';
import './AddDelegationModal.css';
import { useDispatch } from 'react-redux';
import LocalStorage from 'utilities/localStorage';
// import { createDelegation } from '../../../../settings/redux/slice';
import { createDelegation } from '../../../redux/slice';

const { TabPane } = Tabs;
const { Option } = Select;

const AddDelegationModal = ({
  isModalVisible = false,
  onCancel,
  setIsModalOpen,
  onDelegate,
  handleGetActivity,
  allApprovers,
  allPendingEnvelopes,
  onDelegateChange
}) => {
  const [activeTab, setActiveTab] = useState('future');
  const [futureForm] = Form.useForm();
  const [stockForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedEnvelopes, setSelectedEnvelopes] = useState([]);
  // const delegatorId = Form.useWatch('delegator_id', stockForm); // 👀 watch the field
  const delegateId = Form.useWatch('delegate_id', stockForm); // 👈 NEW

  const dispatch = useDispatch();
  const user = LocalStorage.getItem('gnfa_user');
  console.log('user?.user_details?.role', user?.user_details?.role);
  // Mock data for approvers
  const approvers = allApprovers;
  const envelopes = allPendingEnvelopes || [];

  const getDisabledEnvelopeIds = () => {
    if (!delegateId) return [];

    return envelopes
      .filter((envelope) =>
        // envelope.envelope_approvers.some(
        (envelope.envelope_approvers || []).some(
          (approver) =>
            approver.approver_id === delegateId ||
            approver.del_id === delegateId
        )
      )
      .map((envelope) => envelope.id);
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    // Reset forms when switching tabs
    futureForm.resetFields();
    stockForm.resetFields();
    setSelectedEnvelopes([]);
  };

  const handleModalClose = () => {
    futureForm.resetFields();
    stockForm.resetFields();
    setSelectedEnvelopes([]);
    if (setIsModalOpen) {
      setIsModalOpen(false);
    }
    if (onCancel) {
      onCancel();
    }
  };

  const handleFutureSubmit = async (values) => {
    setLoading(true);
    try {
      const delegationData = {
        type: 'future',
        delegation_start: values.delegation_start.format('YYYY-MM-DD hh:mm:ss'),
        delegation_end: values.delegation_end.format('YYYY-MM-DD hh:mm:ss'),
        delegator_id: values.delegator_id,
        delegate_id: values.delegate_id
      };
      console.log('Delegation Data:', delegationData);
      // Simulate API call
      // await new Promise((resolve) => setTimeout(resolve, 1000));
      dispatch(createDelegation(delegationData)).then((response) => {
        if (response.payload.success) {
          message.success(response.payload.message);
          setIsModalOpen(false);
          // handlegetCostCenterNum();
          handleGetActivity();
        } else {
          message.error(response.payload.message);
        }
      });

      // message.success('Future delegation set up successfully');

      if (onDelegate) {
        onDelegate('future', delegationData);
      }

      if (handleGetActivity) {
        handleGetActivity();
      }

      handleModalClose();
    } catch (error) {
      message.error('Failed to set up delegation');
    } finally {
      setLoading(false);
    }
  };

  const handleStockSubmit = async (values) => {
    console.log('Delegation values:', values);
    if (selectedEnvelopes.length === 0) {
      message.error('Please select at least one envelope');
      return;
    }

    setLoading(true);
    try {
      const delegationData = {
        type: 'stock',
        delegator_id: values.delegator_id,
        delegate_id: values.delegate_id,
        env_ids: selectedEnvelopes
      };
      console.log('Delegation Data:', delegationData);
      // Simulate API call
      // await new Promise((resolve) => setTimeout(resolve, 1000));
      console.log('Submitting delegation:', delegationData);

      // await axios.post('/api/delegations', delegationData); // Single endpoint
      dispatch(createDelegation(delegationData)).then((response) => {
        if (response.payload.success) {
          message.success(response.payload.message);
          setIsModalOpen(false);
          // handlegetCostCenterNum();
          handleGetActivity();
        } else {
          message.error(response.payload.message);
        }
      });

      // message.success('Stock delegation set up successfully');

      if (onDelegate) {
        onDelegate('stock', delegationData);
      }

      if (handleGetActivity) {
        handleGetActivity();
      }

      handleModalClose();
    } catch (error) {
      message.error('Failed to set up delegation');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.user_details?.id) {
      const delegatorId = user.user_details.id;
      futureForm.setFieldsValue({ delegator_id: delegatorId });
      stockForm.setFieldsValue({ delegator_id: delegatorId });
    }
  }, [user, futureForm, stockForm]);

  const envelopeColumns = [
    {
      title: '',
      dataIndex: 'id',
      width: 50,
      // render: (id) => (
      //   <Checkbox
      //     checked={selectedEnvelopes.includes(id)}
      //     onChange={(e) => {
      //       if (e.target.checked) {
      //         setSelectedEnvelopes([...selectedEnvelopes, id]);
      //       } else {
      //         setSelectedEnvelopes(
      //           selectedEnvelopes.filter((item) => item !== id)
      //         );
      //       }
      //     }}
      //   />
      // )
      render: (id) => {
        const disabledEnvelopeIds = getDisabledEnvelopeIds();
        const isDisabled = disabledEnvelopeIds.includes(id);
        const isChecked = selectedEnvelopes.includes(id);

        return (
          <Checkbox
            checked={isChecked}
            disabled={isDisabled}
            onChange={(e) => {
              const newSelected = e.target.checked
                ? [...selectedEnvelopes, id]
                : selectedEnvelopes.filter((item) => item !== id);
              setSelectedEnvelopes(newSelected);
              stockForm.setFieldsValue({ env_ids: newSelected }); // sync form value
            }}
          />
        );
      }
    },
    {
      title: 'Envelope ID',
      dataIndex: 'id',
      render: (id) => `#${id}`
    },
    {
      title: 'Name',
      // dataIndex: 'name'
      dataIndex: 'title'
    }
    // {
    //   title: 'Status',
    //   dataIndex: 'status',
    //   render: (status) => (
    //     <span
    //       className={`status-badge ${
    //         status === 'active' ? 'status-active' : 'status-pending'
    //       }`}
    //     >
    //       {status}
    //     </span>
    //   )
    // },
    // {
    //   title: 'View',
    //   dataIndex: 'id',
    //   width: 80,
    //   render: () => <CustomButton type="text" icon={<EyeOutlined />} />
    // }
  ];

  // const handleSelectAll = (e) => {
  //   if (e.target.checked) {
  //     setSelectedEnvelopes(envelopes.map((env) => env.id));
  //   } else {
  //     setSelectedEnvelopes([]);
  //   }
  // };

  const isAllSelected = selectedEnvelopes.length === envelopes.length;
  const isIndeterminate =
    selectedEnvelopes.length > 0 && selectedEnvelopes.length < envelopes.length;

  const renderFutureTab = () => (
    <Form
      form={futureForm}
      onFinish={handleFutureSubmit}
      layout="vertical"
      className="ant-form ant-form-vertical delegation-form"
    >
      <Row gutter={16}>
        <Col span={12}>
          <FormItem
            label="Start Date"
            name="delegation_start"
            rules={[{ required: true, message: 'Please select start date' }]}
          >
            <DatePicker
              placeholder="Select dates"
              format="YYYY-MM-DD"
              disabledDate={(current) =>
                current && current < moment().startOf('day')
              }
              suffixIcon={<CalendarOutlined />}
              style={{ width: '100%' }}
            />
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem
            label="End Date"
            name="delegation_end"
            rules={[
              { required: true, message: 'Please select end date' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const startDate = getFieldValue('delegation_start');
                  if (!startDate || !value || value.isAfter(startDate)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error('End date must be after start date')
                  );
                }
              })
            ]}
          >
            <DatePicker
              placeholder="Select end date"
              format="YYYY-MM-DD"
              disabledDate={(current) => {
                const startDate = futureForm.getFieldValue('delegation_start');
                return current && startDate && current <= startDate;
              }}
              suffixIcon={<CalendarOutlined />}
              style={{ width: '100%' }}
            />
          </FormItem>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <FormItem
            label="Assign From Approver"
            name="delegator_id"
            rules={[{ required: true, message: 'Please select an approver' }]}
          >
            {user?.user_details?.role === 'user' ? (
              <Select disabled>
                <Option value={user?.user_details?.id}>
                  {user?.user_details?.display_name} - (
                  {user?.user_details?.email})
                </Option>
              </Select>
            ) : (
              <Select
                placeholder="Select approver"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option?.children
                    ?.toString()
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {approvers.map((approver) => (
                  <Option key={approver.id} value={approver.id}>
                    {`${approver.display_name} - (${approver.email})`}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
      </Row>

      <Row>
        {/* <Col span={24}>
          <FormItem
            label="Assign To Approver"
            name="assignTo"
            rules={[{ required: true, message: 'Please select approver' }]}
          >
            <Select placeholder="Select approver">
              {approvers.map((approver) => (
                <Option key={approver.id} value={approver.id}>
                  {approver.display_name} - ({approver.email})
                </Option>
              ))}
            </Select>
          </FormItem>
        </Col> */}
        <Col span={24}>
          <FormItem
            label="Assign To Approver"
            name="delegate_id"
            rules={[
              {
                required: true,
                message: 'Please select an approver to assign to.'
              }
            ]}
          >
            <Select
              placeholder="Select approver"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children
                  ?.toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {approvers.map((approver) => (
                <Option key={approver.id} value={approver.id}>
                  {`${approver.display_name} - (${approver.email})`}
                </Option>
              ))}
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>
  );

  const renderStockTab = () => (
    <Form
      form={stockForm}
      onFinish={handleStockSubmit}
      layout="vertical"
      className="ant-form ant-form-vertical delegation-form"
      onValuesChange={(changedValues) => {
        // if ('delegator_id' in changedValues) {
        //   onDelegatorChange?.(changedValues.delegator_id);
        // }
        if ('delegate_id' in changedValues) {
          onDelegateChange?.(changedValues.delegate_id);
        }
      }}
    >
      <FormItem name="env_ids" hidden>
        <Input />
      </FormItem>

      <Row>
        <Col span={24}>
          <FormItem
            label="Assign From Approver"
            name="delegator_id"
            rules={[{ required: true, message: 'Please select an approver' }]}
          >
            {user?.user_details.role === 'user' ? (
              <Select disabled>
                <Option value={user?.user_details?.id}>
                  {user?.user_details?.display_name} - (
                  {user?.user_details?.email})
                </Option>
              </Select>
            ) : (
              <Select
                placeholder="Select approver"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option?.children
                    ?.toString()
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {approvers.map((approver) => (
                  <Option key={approver.id} value={approver.id}>
                    {`${approver.display_name} - (${approver.email})`}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <FormItem
            label="Assign To Approver"
            name="delegate_id"
            rules={[
              {
                required: true,
                message: 'Please select an approver to assign to.'
              }
            ]}
          >
            <Select
              placeholder="Select approver"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children
                  ?.toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {approvers.map((approver) => (
                <Option key={approver.id} value={approver.id}>
                  {`${approver.display_name} - (${approver.email})`}
                </Option>
              ))}
            </Select>
          </FormItem>
        </Col>
      </Row>

      <div className="envelope-section">
        <div className="envelope-header">
          <h4>Select Envelopes</h4>
          <span className="selection-count">
            {selectedEnvelopes.length} of {envelopes.length} selected
          </span>
        </div>

        <div className="select-all-wrapper">
          <Checkbox
            checked={isAllSelected}
            indeterminate={isIndeterminate}
            // onChange={handleSelectAll}
            onChange={(e) => {
              const allIds = e.target.checked
                ? envelopes.map((env) => env.id)
                : [];
              setSelectedEnvelopes(allIds);
              stockForm.setFieldsValue({ env_ids: allIds });
            }}
          >
            Select All
          </Checkbox>
        </div>

        <Table
          dataSource={envelopes}
          columns={envelopeColumns}
          pagination={false}
          size="small"
          className="envelope-table"
          rowClassName="envelope-row"
        />
      </div>
    </Form>
  );

  const getFooterButtons = () => {
    const currentForm = activeTab === 'future' ? futureForm : stockForm;
    const isStockInvalid =
      activeTab === 'stock' && selectedEnvelopes.length === 0;

    return (
      <Form
        form={currentForm}
        onFinish={
          activeTab === 'future' ? handleFutureSubmit : handleStockSubmit
        }
        layout="vertical"
        className="ant-form ant-form-vertical"
      >
        <Row>
          <Col className="text-left" span={12}>
            <CustomButton onClick={handleModalClose}>Cancel</CustomButton>
          </Col>
          <Col className="text-right" span={12}>
            <CustomButton
              type="primary"
              // htmlType="submit"
              loading={loading}
              disabled={isStockInvalid}
              onClick={() => currentForm.submit()}
            >
              {loading ? 'Delegating...' : 'Delegate'}
            </CustomButton>
          </Col>
        </Row>
      </Form>
    );
  };

  return (
    <CustomModal
      footer={getFooterButtons()}
      onCancel={handleModalClose}
      visible={isModalVisible}
      title="Set up Delegation"
      width={600}
      className="delegation-modal"
    >
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        className="delegation-tabs"
      >
        <TabPane tab="Future" key="future">
          {renderFutureTab()}
        </TabPane>
        <TabPane tab="Stock" key="stock">
          {renderStockTab()}
        </TabPane>
      </Tabs>
    </CustomModal>
  );
};

export default AddDelegationModal;
